<!-- 激励页面 -->
<template>
    <div style="background: #eee">
      <van-sticky>
        <van-nav-bar
          title="激励费用详情"
          left-text="返回"
          left-arrow
          @click-left="goback"
        />
      </van-sticky>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell-group
          v-for="(item, index) in orderList"
          :key="index"
          style="margin: 1.2rem; text-align: left"
          inset
        >
          <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
            {{ item.incentiveName }}
          </div>
          <van-field
            label="激励类型"
            :value="item.incentiveType == 1 ? '正激励' : '负激励'"
            input-align="right"
            readonly
            label-width="6rem"
          />
          <van-field
            label="激励备注"
            :value="item.incentiveRemarks"
            input-align="right"
            readonly
            label-width="5rem"
          />
          <van-field
            label="备注"
            :value="item.remarks"
            input-align="right"
            type="textarea"
            autosize
            rows="1"
            readonly
            label-width="5rem"
          />
          <van-field
            label="金额"
            :value="item.amount"
            input-align="right"
            readonly
            label-width="5rem"
          />
          <van-field
            label="附件"
            :value="item.attachmentIds != '' ? item.attachmentIds.split(',').length : '无'"
            input-align="right"
            readonly
            label-width="5rem"
          />
          <van-cell title="关联订单" :is-link="item.relatedOrderIds!=''"
            :value="item.relatedOrderIds!='' ? '查看关联订单' : '无'"
            @click="seeRelatedOrder(item)"
          />
          <van-field
            label="对应师傅"
            :value="item.responsibleUserIdStr || '-'"
            input-align="right"
            readonly
            label-width="5rem"
          />
          <van-row style="padding: 1rem">
            <van-col span="5.5">
              <van-button
                v-if="item.attachmentIds != ''"
                type="default"
                size="small"
                @click="seeFile(item)"
                >查看附件列表</van-button
              >
            </van-col>
        </van-row>
        </van-cell-group>
      </van-list>
    </div>
  </template>
  <script>
  export default {
    name: "InstallPage",
    data() {
      return {
        loading: false,
        finished: false,
        orderList:[],
      };
    },
    methods: {
      seeFile(item){
        this.$router.push({
          path:'/settlement/fileList',
          query:{
            attachmentIds:item.attachmentIds,
          }
        })
      },
      seeRelatedOrder(item){
        if(item.relatedOrderIds ==''){
          return false;
        }else{
          this.$router.push({
            path:'/settlement/relatedOrder',
            query:{
              relatedOrderIds:item.relatedOrderIds,
              settlementBatchName:this.$route.query.settlementBatchName,
              responsibleUserId:this.$route.query.responsibleUserId,
            }
          })
        }
      },
      goback() {
        //返回上一页
        this.$router.go(-1);
      },
      onLoad() {
      this.finished = false;
      this.getPageData();
    },
    getPageData(){
      //获取分页数据
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/h5/listModuleDetail",
        method: "get",
        params:{
          id:this.$route.query.id,
          module:'settlementIncentiveList'
        }
      }).then(res=>{
        this.orderList = res.data.data.settlementIncentiveList;
        this.loading = false;
        this.finished = true;
      })
    }
    },
  };
  </script>
  